const terrains = {
        // view structure
        title: String("Terrain"),
        terrainsTableTitle: String("Manage my terrains"),

        // Table headers
        terrainName: String("Terrain name"),
        terrainAddressMunicipality: String("Municipality"),
        terrainHomogeneousGrowingArea: String("Homogeneous growing area"),
        terrainCoordinates: String("Coordinates"),
        terrainPlotActionHeader: String("Actions"),

        // Buttons
        terrainNewTerrainButton: String("Add new terrain"),
        terrainPlotActionModify: String("Edit"),
        terrainPlotActionDelete: String("Delete"),
        deletePromptModalTitle: String("Delete terrain"),
        deleteModalBody: String("You are about to delete a terrain. Once deleted it's impossible to restore it. Are you sure you want to delete it?"),
        deleteModalAccept: String("Delete"),
        deleteModalRejec: String("Cancelar"),
};

export default terrains;